module.exports = __webpack_public_path__ + "static/media/backlift-msg.46db444f.svg";